// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"522e7b6d","917":"e99bd29f"}[chunkId] + ".chunk.js";
};